import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'react-admin';

const AddNewDeptApprovalEntryButton = ({ record }) => (
    <Button
        variant="contained"
        component={Link}
        to={`/new-dept-approval-entry/${record.id}`}
        label="Add dept approval entry"
        style={{ marginTop: '1em', marginBottom: '1em' }}
    />
);

export default AddNewDeptApprovalEntryButton;
